module.exports = {
          srcSet: __webpack_public_path__ + "assets/1d34bfd1a82df995d69caf12a3cedd97.webp"+" 63w",
          images:[ {path: __webpack_public_path__ + "assets/1d34bfd1a82df995d69caf12a3cedd97.webp",width: 63,height: 63}],
          src: __webpack_public_path__ + "assets/1d34bfd1a82df995d69caf12a3cedd97.webp",
          toString:function(){return __webpack_public_path__ + "assets/1d34bfd1a82df995d69caf12a3cedd97.webp"},
          
          width: 63,
          height: 63
        }